import * as GC from '@grapecity/spread-sheets';
import { spreadsheetConfig } from '@shared/spreadsheet/spreadsheet-config';

/* Constants */
export const HEADER_AREA = GC.Spread.Sheets.SheetArea.colHeader;
export const DEFAULT_FIELDS = {
  RESULT_TYPE: 'Numeric',
  DATATABLE_TYPE: 'GENERIC',
  INTERPOLATION: 'EXACT',
};
export const MINIMUM_ROWS = 50;
export const PADDING_ROWS = 2;

/* Column Definition */
export const LOOKUP_TABLE_PROPERTIES_HEADERS = [];
export const NAME_COL_POS = 0;
LOOKUP_TABLE_PROPERTIES_HEADERS[NAME_COL_POS] = 'Name';
export const MNEMONIC_COL_POS = 1;
LOOKUP_TABLE_PROPERTIES_HEADERS[MNEMONIC_COL_POS] = 'Mnemonic';
export const RESULT_TYPE_COL_POS = 2;
LOOKUP_TABLE_PROPERTIES_HEADERS[RESULT_TYPE_COL_POS] = 'Result Type';
export const DATATABLETYPE_COL_POS = 3;
LOOKUP_TABLE_PROPERTIES_HEADERS[DATATABLETYPE_COL_POS] = 'Datatable Type';
export const DESCRIPTION_COL_POS = 4;
LOOKUP_TABLE_PROPERTIES_HEADERS[DESCRIPTION_COL_POS] = 'Description';
export const DIMENSION_COL_POS = 5;
LOOKUP_TABLE_PROPERTIES_HEADERS[DIMENSION_COL_POS] = 'Dimensions';
export const GROUP_HEADERS = [];
export const DEFINITION_COL_POS = 0;
GROUP_HEADERS[DEFINITION_COL_POS] = 'Definition';
export const DATATYPE_COL_POS = 1;
GROUP_HEADERS[DATATYPE_COL_POS] = 'Data Type';
export const INTERPOLATION_COL_POS = 2;
GROUP_HEADERS[INTERPOLATION_COL_POS] = 'Interpolation';

export const DIM1_GROUP = {
  startCol: DIMENSION_COL_POS + 1,
  spanCol: GROUP_HEADERS.length,
  title: 'Dimension 1',
  headers: GROUP_HEADERS,
};
export const DIM2_GROUP = {
  startCol: DIMENSION_COL_POS + 1 + GROUP_HEADERS.length,
  spanCol: GROUP_HEADERS.length,
  title: 'Dimension 2',
  headers: GROUP_HEADERS,
};
export const DIM3_GROUP = {
  startCol: DIMENSION_COL_POS + 1 + GROUP_HEADERS.length * 2,
  spanCol: GROUP_HEADERS.length,
  title: 'Dimension 3',
  headers: GROUP_HEADERS,
};

/** Cell styles */
export const hLeftAlignStyle = spreadsheetConfig.align.left;
export const hCenterAlignStyle = spreadsheetConfig.align.center;
export const hRightAlignStyle = spreadsheetConfig.align.right;

export const DISABLED_CELL_STYLE: GC.Spread.Sheets.Style = new GC.Spread.Sheets.Style();
DISABLED_CELL_STYLE.backColor = spreadsheetConfig.disabledCellBackColor;

/* Default values before retrieving from database*/
export const DEFAULT_DATATABLE_TYPES = ['GENERIC']; // , 'Prepayment', 'Pricing', 'Seasonality'];
export const DEFAULT_INTERPOLATION_VALUES = ['EXACT', 'LOW', 'HIGH', 'LINEAR', 'LOGLINEAR'];
export const PH_DATA_TYPES = ['Numeric', 'Text', 'Date'];
export const DEFAULT_DIMENSION_DEFINITION: DimensionDefinitionItem[] = [
  { name: 'Mnemonic', type: PH_DATA_TYPES[1] },
  { name: 'AccountNum', type: PH_DATA_TYPES[0] },
  { name: 'MthsFromCP', type: PH_DATA_TYPES[0] },
  { name: 'PdNum', type: PH_DATA_TYPES[0] },
  { name: 'ScenarioMnemonic', type: PH_DATA_TYPES[1] },
];
export interface DimensionDefinitionItem {
  name: string;
  type: string;
}
